import { createAsyncThunk } from "@reduxjs/toolkit";
import { userDeletionRequestService } from "@modules/setting/userManagement/userDeletionRequest.service.ts";

export const createUserDeletionRequest = createAsyncThunk(
  "userDeletionRequest/create",
  async ({ userId, onSuccess, onError }: { userId: string; onSuccess?: () => void; onError?: () => void }) => {
    try {
      const request = await userDeletionRequestService.createRequest(userId);
      if (onSuccess) onSuccess();
      return request;
    } catch {
      if (onError) onError();
    }
  }
);
